import { render, staticRenderFns } from "./ScoringProfilesCreate.vue?vue&type=template&id=4e4bf62b&scoped=true"
import script from "./ScoringProfilesCreate.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4bf62b",
  null
  
)

export default component.exports